import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { HomeActions, HomeSelectors } from 'src/app/store';

@Component({
    selector: 'app-news-details',
    templateUrl: './news-details.component.html',
    styleUrls: ['./news-details.component.scss'],
})
export class NewsDetailsComponent implements OnInit, OnDestroy {
    vm$ = this.store.select(HomeSelectors.selectSelectedNewsDetails);

    constructor(private route: ActivatedRoute, private store: Store) {}

    ngAfterViewInit() {}

    ngOnInit() {
        this.route.params.subscribe((params) => {
            const id = +params['id'];
            this.store.dispatch(HomeActions.setSelectedNewsId({ id: id }));

            // Hack: Scrolls to the top of entire Page with 0 coordinates after page view initialized
            setTimeout(() => {
                let top = document.getElementsByTagName('html')[0]; 
                if (top !== null) {
                    top.scrollIntoView();
                    top = null;
                }
            }, 10);
        });
    }

    ngOnDestroy() {
        this.store.dispatch(HomeActions.cleanupSelectedNewsId());
    }
}

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlContentCleanup',
})
export class HtmlCleanupPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }

        // Regular expressions to match the date-related and title elements
        const dateRegex = /<p><strong>[A-Za-z]+ \d{4}<\/strong><\/p>\n\n/g;

        // Remove date-related and title elements from the HTML content
        const cleanedValue = value.replace(dateRegex, '');

        return cleanedValue;
    }
}

@Component({
    selector: 'app-scroll-top',
    template: '',
})
export class ScrollTopComponent implements OnInit {
    ngOnInit() {
        window.scrollTo(0, 0);
    }
}
